<template>
  <div
    :class="cssClasses()"
    class="popup-wrapper dextra-mfv-page"
    @click="hide"
  >
    <div
      class="popup-inner"
      @click.stop=""
    >
      <span
        class="popup-close"
        @click="hide"
      />
      <h3 v-if="data.headlines">
        {{ data.headline }}
      </h3>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-html="data.text" />
      <p
        v-if="showLastEventId"
        class="error-code"
      >
        Error-Code: {{ lastEventId }}
      </p>
      <div v-if="data.buttons">
        <hr>
        <div
          v-for="button in data.buttons"
          :key="button"
        >
          <TheButton
            :text="button.text"
            :theme="button.theme"
            @click="button.click"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PubSub from '@helper/PubSub'
import TheButton from '@cmp/Button'
import Raven from 'raven-js'
import ENV from '@root/src/javascripts/getEnv'

export default {
  name: 'Popup',
  components: {
    TheButton,
  },
  data() {
    return {
      isError: false,
      lastEventId: null,
      isActive: false,
      data: {},
    }
  },
  computed: {
    showLastEventId() {
      return ENV.enableDebug && this.lastEventId && this.isError
    },
  },
  created () {
    PubSub.subscribe('show-popup', (data) => {
      this.data = data
      this.isError = !!data.isError
      this.show()
    })

    PubSub.subscribe('hide-popup', () => {
      this.hide()
    })

    PubSub.subscribe('reset-popup', () => {
      this.reset()
    })

    PubSub.subscribe('key-ESC', () => {
      this.reset()
    })
  },
  methods: {
    show () {
      this.isActive = true
      this.lastEventId = Raven.lastEventId()
    },
    hide () {
      this.isActive = false
    },
    reset () {
      this.hide()
      this.data = {}
    },
    cssClasses () {
      return {
        error: this.isError,
        'show-popup': this.isActive,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "styles/index";
</style>
<style lang="scss">
  @import "styles/buttons_index";
</style>
